export function calculateBodyLength(body) {
  if (typeof body === "string") {
    var len = body.length;

    for (var i = len - 1; i >= 0; i--) {
      var code = body.charCodeAt(i);
      if (code > 0x7f && code <= 0x7ff) len++;else if (code > 0x7ff && code <= 0xffff) len += 2;
    }

    return len;
  } else if (typeof body.byteLength === "number") {
    // handles Uint8Array, ArrayBuffer, Buffer, and ArrayBufferView
    return body.byteLength;
  } else if (typeof body.size === "number") {
    // handles browser File object
    return body.size;
  }
}